/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBaseResponse as LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse } from '../../models/Limelight/Babylon/DataObjects/DTO/dto-vehicle-base-response';

export interface V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params {
  applicationId: string;
}

export function v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain(http: HttpClient, rootUrl: string, params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>;
    })
  );
}

v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain.PATH = '/v4/public/application/vehicle/{applicationId}/vehicle/info';
